import React from 'react';
import cx from 'classnames';
import styles from '@/common/containers/UserIntro/styles.less';
import img from '@/common/assets/introThird.png';
import { Trans, useTranslation } from 'react-i18next';
import CopyrightSup from '@/common/components/CopyrightSup';
import { Typography } from '@mui/material';
import { getMarketingSiteUrl } from '@/app/config';
import { useLocale } from '@/common/hooks';

const Third = () => {
  const { t } = useTranslation();
  const { locale } = useLocale();
  const legalDisclaimerUrl = getMarketingSiteUrl('/legal-disclaimer', locale);
  const copyrightSup = <CopyrightSup />;
  return (
    <div className={cx(styles.screen, styles.first)}>
      <div className={cx(styles.firstItem, styles.firstImgContainer)}>
        <div className={cx(styles.firstImgContainerBack, styles.thirdBack)} />
        <img
          className={styles.firstImgContainerImg}
          src={img}
          alt={t('a women')}
        />
      </div>
      <div className={cx(styles.firstItem, styles.thirdText)}>
        <h4 className={cx(styles.screenTitle, styles.firstTitle)}>
          {t('Who can use it?')}
        </h4>
        <div className={cx(styles.firstBody, styles.thirdBody)}>
          <p>
            <Trans
              i18nKey="PAEM After Care<copyrightSup/> can be used by anyone that is assigned the responsibility of managing the estate of the decedent. It could be a formally designated Executor, a Liquidator (in Quebec), an estate trustee, an estate administrator, a personal representative appointed by the court, an heir, or even a person assisting a formally designated Executor."
              components={{ copyrightSup }}
            />
          </p>
          <Typography sx={{ mt: 10, letterSpacing: '0.15px' }}>
            <Trans
              i18nKey="<1>Disclaimer:</1> The information provided by this product is for general informational purposes only and is not legal advice. See <2>Legal Disclaimer</2>."
              components={{
                1: <b />,
                2: (
                  <a href={legalDisclaimerUrl} target="_blank" rel="noreferrer">
                    {t('Legal Disclaimer')}
                  </a>
                ),
              }}
            />
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default Third;
